import { render } from "./ShiftManagement.vue?vue&type=template&id=418b5fd8&scoped=true"
import script from "./ShiftManagement.vue?vue&type=script&lang=js"
export * from "./ShiftManagement.vue?vue&type=script&lang=js"

import "./ShiftManagement.vue?vue&type=style&index=0&id=418b5fd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-418b5fd8"]])

export default __exports__